import React from "react";
import DefaultLayout from "./common/DefaultLayout";

import {
  useGetExhibitorByIdQuery, useGetExhibitorByTokenQuery, BadgeModel,
} from '../api'

import { useAppContext } from '../contexts/app'
import { useParams, useLocation } from "react-router-dom";
import { getAuthQueries } from "../utils";


const DownloadBadgePage = () => {
  const location = useLocation()
  const key = getAuthQueries(location.search)[1]
  const { badgeId } = useParams()
  const { authToken, downloadBadge } = useAppContext()
  const [isDownloading, setIsDownloading] = React.useState<boolean>(false);
  const [isDownloaded, setIsDownloaded] = React.useState<boolean>(false);
  const byTokenRes = useGetExhibitorByTokenQuery({
    fetchPolicy: 'network-only',
    variables: {
      token: authToken!
    }
  });
  const byIdRes = useGetExhibitorByIdQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: key!
    }
  });

  if (!byTokenRes.data && !byIdRes.data) {
    return <></>
  }
  let exhibitor;
  if (byTokenRes.data) {
    exhibitor = byTokenRes.data.getExhibitorByToken;
  } else {
    exhibitor = byIdRes.data!.getExhibitorById;
  }


  const badge = exhibitor.badges.find(badge => badge.id === badgeId);
  function download() {
    setIsDownloading(true)
    downloadBadge(badge as BadgeModel, key).then(() => {
      setIsDownloaded(true)
      setIsDownloading(false)
    });
  }
  if (!isDownloading && !isDownloaded) {
    download()
  }
  return (
    <DefaultLayout isDownload exhibition={exhibitor.exhibition}>
      <div>自動でダウンロードが始まります。</div>
      {!isDownloading && <div className="btn mt-2" onClick={() => download()}>ダウンロード</div>}
      {isDownloading && <div className="btn loading mt-2">ダウンロード中<i className="fa fa-sync-alt fa-spin"></i></div>}
    </DefaultLayout>
  );
}

export default DownloadBadgePage;
